import React from 'react';

import { TextField } from 'mui-rff';
import {useSelector} from 'react-redux';
import {applicationSelector} from "../../redux/application";

export default function TextFieldAdapter({disabled, variant, ...rest}) {

  const {loader} = useSelector(applicationSelector);

  return (<TextField
    disabled={disabled || loader}
    variant={variant || 'outlined'}
    {...rest}
  />)

}